/** @jsxImportSource @emotion/react */
import type { ReactNode } from 'react';

import {
  DEFAULT_SCOPE_FILTER_STYLES,
  type ScopeFilterStyles,
} from './scopeFilterStyles';

export type ScopeFilterGroupsTypes = {
  id: string;
  label: string;
  content: (styles: ScopeFilterStyles) => ReactNode;
};

export const ScopeFilterGroups = ({
  groups,
  styles = DEFAULT_SCOPE_FILTER_STYLES,
}: {
  groups: readonly ScopeFilterGroupsTypes[];
  styles?: ScopeFilterStyles;
}) => (
  <div data-testid={'scope-attention-filter-groups'}>
    {groups.map(({ id, label, content }, index) => (
      <section
        key={id}
        css={[styles.group, index > 0 && styles.divider]}
        data-testid={`scope-attention-filter-group-${id}`}
      >
        <div css={styles.heading}>{label}</div>
        {content(styles)}
      </section>
    ))}
  </div>
);
